import { render, staticRenderFns } from "./ButtonExternal.vue?vue&type=template&id=50fe3260&scoped=true&"
import script from "./ButtonExternal.vue?vue&type=script&lang=ts&"
export * from "./ButtonExternal.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonExternal.vue?vue&type=style&index=0&id=50fe3260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe3260",
  null
  
)

export default component.exports